import axios from 'axios'
import store from './store'

const axiosCommonConfig = Object.freeze({
  timeout: 30000000,
  // baseURL: 'http://bjx.reemii.cn/bjcx',
  baseURL: 'http://localhost:8000/',
  // baseURL: '',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json;charset=UTF-8'
  }
})

export const httpRequestMethods = Object.freeze({
  GET: 'get',
  POST: 'post',
  DELETE: 'delete',
  PUT: 'put',
  PATCH: 'patch'
})

export const axiosInstance = axios.create(axiosCommonConfig)

// http request 拦截器
axiosInstance.interceptors.request.use(function (config) {
  return config
}, function (error) {
  console.error('Error: Http request failed!, %o', error.message || error)
  return Promise.reject(error)
})

// http response 拦截器
axiosInstance.interceptors.response.use(function (response) {
  let code = response.data.code
  if ([0, -1].indexOf(code) > -1) {
    if (code === -1) {
      return Promise.reject(new Error(response.data.msg))
    }
  }
  return response.data
},
function (error) {
  return Promise.reject(error)
})

export const baseAPIRequest = function (endPoint, method, params) {
  let config = {
    method: method,
    url: endPoint + (store.getters.oilArea ? '?area=' + store.getters.oilArea : ''),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  }
  if (['post', 'put', 'patch'].includes(method)) {
    config.data = JSON.stringify(params)
  } else {
    config.params = params
  }
  return axiosInstance.request(config).then(function (data) {
    return Promise.resolve(data)
  }, function (error) {
    return Promise.reject(error)
  }).catch(function (e) {
    console.log(e)
    return Promise.reject(e)
  })
}



// WEBPACK FOOTER //
// ./src/axios_init_p.js